<!--
 * Base-Loading 组件属性列表
 *
 * @props:{loading} Boolean
 * @description: 是否显示加载动画
 *
 * @props:{background} String
 * @description: 加载动画	遮罩背景色
 *
 * @props:{text} String
 * @description: 显示在加载图标下方的加载文案
 *
 * @props:{full} Boolean
 * @description: 是否高度为父级100%
 *
 * * 扩展支持Base-Empty属性配置
 *
 * 插槽列表
 * @slots: { default } VNode
 * @description: 加载完成填充内容
 *
 * * 默认插槽不存在内容 则显示Empty组件
-->
<template>
  <div class="base-loading" ref="base-loading" :style="loadingStyle">
    <base-empty
      v-if="!$slots.default && !loading"
      :type="this.type"
      :size="this.size"
      :description="this.description"
    ></base-empty>
    <template v-if="$slots.default">
      <div v-show="!loading" class="base-loading__wrapper">
        <slot> </slot>
      </div>
    </template>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import BaseEmpty from "@/components/base-empty";
// import { pxToRem } from "@/utils/ruoyi";

export default {
  name: "base-loading",
  props: {
    ...BaseEmpty.props,
    loading: {
      type: Boolean,
      default: true,
    },
    background: String,
    text: String,
    full: {
      type: Boolean,
      default: true,
    },
    minHeight: {
      type: [String, Number],
      default: "128px",
    },
  },
  data() {
    return {
      loadingInstance: null,
    };
  },
  computed: {
    loadingStyle() {
      return {
        height: this.full ? "100%" : "auto",
        // minHeight: this.loading ? this.minHeight : "0",
      };
    },
  },
  watch: {
    loading(v) {
      if (v) {
        this.loadingService();
      } else {
        this.loadingInstance && this.loadingInstance.close();
      }
    },
  },
  mounted() {
    if (this.loading) this.loadingService();
  },
  beforeDestroy() {
    this.loadingInstance && this.loadingInstance.close();
  },
  methods: {
    /**
     * @description: loading 实例化
     * @param {*}
     * @return {*}
     */
    loadingService() {
      this.loadingInstance = Loading.service({
        target: this.$refs["base-loading"],
        text: this.text || "加载中...",
        customClass: "base-loading-loading",
        background: this.background
          ? this.background + "!important"
          : undefined,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.base-loading {
  position: relative;

  &__wrapper {
    height: 100%;
  }
}
</style>
